const Loader = () => {
  const elements = [];
  for (let i = 1; i <= 12; i += 1) {
    elements.push(<div className={`hu-loader-element-${i}`} key={i} />);
  }

  return (
    <div className="hu-loader">
      {elements}
    </div>
  );
};

export default Loader;
